import { Icon } from './_Icon';
export const PlusIcon = (props) => <Icon {...props} d="M12 5v14 M5 12h14" />;
